import { createFileRoute } from "@tanstack/react-router";
import NextEmptyResponse from "@/components/NextEmptyResponse";

export const Route = createFileRoute("/_auth/docs_/$documentId/")({
  component: NextEmptyResponse,
});
